import { AlertDialog, AlertDialogProps } from "@components/ui/AlertDialog"
import { proxy, ref, useSnapshot } from "valtio"

function createAlertsStore() {
  const store = proxy({
    alerts: [] as AlertDialogProps[],
    displayAlert(alert: AlertDialogProps) {
      const item = ref(alert)
      store.alerts.push(item)
      return () => {
        store.alerts = store.alerts.filter((a) => a !== item)
      }
    },
  })
  return store
}

export const alerts = createAlertsStore()

export function AlertSystem() {
  const state = useSnapshot(alerts)

  const alertProps = state.alerts.at(-1)

  if (alertProps) {
    return (
      <AlertDialog
        {...(alertProps as AlertDialogProps)}
        forceOpen={true}
        onOpenChange={(open) => {
          if (!open) {
            alerts.alerts.pop()
          }
        }}
        onCancel={() => {
          alerts.alerts.pop()
        }}
      />
    )
  }
  return null
}
